import React, { useState, useEffect } from 'react';
import {
  Progress,
  Box,
  ButtonGroup,
  Button,
  Heading,
  Flex,
  FormControl,
  GridItem,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  InputLeftAddon,
  InputGroup,
  Textarea,
  FormHelperText,
  InputRightElement,
  HStack,
  Stack,
  Tooltip,
  FormErrorMessage,
} from '@chakra-ui/react';

import { useToast } from '@chakra-ui/react';

import axios from 'axios';
import { useMediaQuery } from '@chakra-ui/react';

import {
  validatePhoneNumber,
  validateEmails,
  validateAddress,
} from './Validation';

const Form1 = (props) => {
  // State variables for form inputs
  const [firstName, setFirstName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [lastName, setLastName] = useState('');
  const [dob, setDob] = useState('');
  const [gender, setGender] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [curAddress, setCurAddress] = useState('');
  const [permAddress, setPAdress] = useState('');

  const [confirmEmail, setConfirmEmail] = useState('');

  const [firstNameError, setFirstNameError] = useState(''); // Error state for First Name
  const [lastNameError, setLastNameError] = useState('');
  const [dobError, setDobError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [permAddressError, setPermAddressError] = useState('');
  const [curAddressError, setCurAddressError] = useState('');

  const [userData, setUserData] = useState({});

  const handleLastNameChange = (e) => {
    const value = e.target.value;
    setLastName(value);
  };

  const handleFirstNameChange = (e) => {
    const value = e.target.value;
    setFirstName(value);
  };
  const handleDobChange = (e) => {
    const value = e.target.value;
    setDob(value);
  };

  // ... other event handlers

  useEffect(() => {
    // Validation logic for First Name
    if (/^\d/.test(firstName)) {
      setFirstNameError('First Name cannot start with a number');
    } else {
      setFirstNameError('');
    }

    if (/^\d/.test(lastName)) {
      setLastNameError('First Name cannot start with a number');
    } else {
      setLastNameError('');
    }
    // Validation logic for DOB
    const today = new Date();
    const selectedDob = new Date(dob);

    if (selectedDob > today) {
      setDobError('DOB cannot be greater than today');
    } else {
      setDobError('');
    }
  }, [firstName, dob]);

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhone(value);
    const error = validatePhoneNumber(value);
    setPhoneError(error);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    const error = validateEmails(value, confirmEmail);
    setEmailError(error);
  };

  const handleConfirmEmailChange = (e) => {
    const value = e.target.value;
    setConfirmEmail(value);
    const error = validateEmails(email, value);
    setEmailError(error);
  };
  // error in setPAdress, who wrote it like that?????
  const handlePermAddressChange = (e) => {
    const value = e.target.value;
    setPAdress(value);
    const error = validateAddress(value);
    setPermAddressError(error);
  };

  const handleCurAddressChange = (e) => {
    const value = e.target.value;
    setCurAddress(value);
    const error = validateAddress(value);
    setCurAddressError(error);
  };

  // State variable for show/hide password
  const [show, setShow] = React.useState(false);
  const handleClick = () => setShow(!show);

  // Media query for responsive design
  const [isSmallerThan750] = useMediaQuery('(max-width: 750px)');

  const toast = useToast();

  // Handle form submission
  const handleNext = () => {
    if (!firstName || !dob || !phone || !email || !permAddress || !curAddress) {
      toast({
        title: 'Validation Error',
        description: 'Please fill in all required fields.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return; // Prevent submission if any required field is empty
    }

    if (
      firstNameError ||
      dobError ||
      phoneError ||
      emailError ||
      permAddressError ||
      curAddressError
    ) {
      toast({
        title: 'Validation Error',
        description: 'Please correct the errors in the form.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return; // Prevent submission if there are validation errors
    }

    const formData = {
      firstName: firstName,
      middleName: middleName,
      lastName: lastName,
      dob: dob,
      gender: gender,
      email: email,
      contactDetails: {
        phone: phone,
        permAddress: permAddress,
        curAddress: curAddress,
      },
    };

    // Send form data to the server using Axios
    axios
      .post(
        'https://glb-api.onrender.com/student/form1',
        { formData: formData },
        { withCredentials: true },
      )
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });

    // Call the onNext callback from props to update the step state
    // props.onNext();
  };

  useEffect(() => {
    axios
      .get('https://glb-api.onrender.com/api/user/details', { withCredentials: true })
      .then((res) => {
        console.log(res.data);
        setUserData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      <Box px="150px">
        {/* Form heading */}
        <Heading w="100%" textAlign={'center'} fontSize="5xl" mb="4%">
          User Registration
        </Heading>

        {/* Form controls for first name, middle name, and last name */}
        <Flex
          direction={isSmallerThan750 ? 'column' : 'row'}
          alignItems="center"
          justify="center"
          spacing={4}
        >
          <FormControl
            flex="1"
            m={2}
            isInvalid={!!firstNameError} // Set isInvalid to true when there's an error
            isRequired
          >
            <FormLabel isRequired>First Name</FormLabel>
            {userData.firstName ? ( // Check if firstName is available in userData
    <Input
      id="first-name"
      placeholder="First name"
      boxShadow="md"
      borderColor={!!firstNameError ? 'red.300' : 'transparent'} // Change border color to red when there's an error
      value={userData.firstName} // Populate the field with user data
      isReadOnly // Make the field non-editable
      isDisabled // Make the field appear disabled
      color="gray.400" // Set the text color to gray
    />
  ) : (
    <Input
      id="first-name"
      placeholder="First name"
      boxShadow="md"
      borderColor={!!firstNameError ? 'red.300' : 'transparent'} // Change border color to red when there's an error
      value={firstName} // Allow user input
      onChange={handleFirstNameChange} // Handle user input
    />
  )}
            {firstNameError && (
              <FormErrorMessage color="red.500">
                {firstNameError}
              </FormErrorMessage>
            )}
          </FormControl>

          <FormControl flex="1" m={2}>
            <FormLabel htmlFor="middle-name" fontSize="md">
              Middle name
            </FormLabel>
            <Input
              id="middle-name"
              placeholder="Middle name"
              boxShadow="md"
              borderColor="transparent"
              value={middleName}
              onChange={(e) => {
                setMiddleName(e.target.value);
                console.log(middleName);
              }}
            />
          </FormControl>

          <FormControl flex="1" m={2}  isInvalid={!!lastNameError}>
            <FormLabel htmlFor="last-name" fontSize="md">
              Last name
            </FormLabel>
            {userData.lastName ? ( // Check if lastName is available in userData
    <Input
      id="last-name"
      placeholder="Last name"
      boxShadow="md"
      borderColor={!!lastNameError ? 'red.300' : 'transparent'} // Change border color to red when there's an error
      value={userData.lastName} // Populate the field with user data
      isReadOnly // Make the field non-editable
      isDisabled // Make the field appear disabled
      color="gray.400" // Set the text color to gray
    />
  ) : (
    <Input
      id="last-name"
      placeholder="Last name"
      boxShadow="md"
      borderColor={!!lastNameError ? 'red.300' : 'transparent'} // Change border color to red when there's an error
      value={lastName} // Allow user input
      onChange={handleLastNameChange} // Handle user input
    />
  )}
          </FormControl>
        </Flex>

        {/* More form controls for date of birth, phone number, email, and addresses */}
        {/* (Code for password fields is commented out) */}
        {/* Date of Birth */}
        <Flex
          mt="40px"
          direction={isSmallerThan750 ? 'column' : 'row'}
          width={isSmallerThan750 ? '100%' : '50%'}
          alignItems="center"
          justify="center"
        >
          <Box flex="1" m={2} width={isSmallerThan750 ? '100%' : 'auto'}>
            <FormControl
              flex="1"
              m={2}
              isInvalid={!!dobError} // Set isInvalid to true when there's an error
            >
              <FormLabel isRequired>Date of Birth</FormLabel>
              <Input
                id="dob"
                type="date"
                placeholder="Select DOB"
                boxShadow="md"
                borderColor={!!dobError ? 'red.300' : 'transparent'} // Change border color to red when there's an error
                onChange={handleDobChange}
                value={dob}
              />
              <FormErrorMessage color="red.500">{dobError}</FormErrorMessage>
            </FormControl>
          </Box>

          {/* Phone Number */}
          <Box flex="1" m={2} width={isSmallerThan750 ? '100%' : 'auto'}>
            <FormControl flex="1" m={2} isInvalid={!!phoneError} isRequired>
              <FormLabel isRequired>Phone Number</FormLabel>
              <InputGroup>
                <InputLeftAddon
                  fontSize="xl"
                  children="+91"
                  boxShadow="md"
                  borderColor={!!phoneError ? 'red.300' : 'transparent'}
                />
                <Input
                  id="phoneNo"
                  type="tel"
                  width="100%"
                  placeholder="Phone number"
                  boxShadow="md"
                  borderColor={!!phoneError ? 'red.300' : 'transparent'}
                  onChange={handlePhoneChange}
                  value={phone}
                />
              </InputGroup>
              {phoneError && (
                <FormErrorMessage color="red.500">
                  {phoneError}
                </FormErrorMessage>
              )}
            </FormControl>
          </Box>
        </Flex>

        {/* Email Address */}
        <Flex
          mt="40px"
          direction={isSmallerThan750 ? 'column' : 'row'}
          width={isSmallerThan750 ? '100%' : 'auto'}
          alignItems="center"
          justify="center"
        >
          <Box flex="1" m={2} width="100%">
            <FormControl flex="1" m={2} isInvalid={!!emailError} isRequired>
              <FormLabel isRequired>Email Address</FormLabel>
              {userData.email ? ( // Check if email is available in userData
    <Input
      id="email"
      type="email"
      placeholder="Enter E-mail"
      boxShadow="md"
      borderColor={!!emailError ? 'red.300' : 'transparent'} // Change border color to red when there's an error
      value={userData.email} // Populate the field with user data
      isReadOnly // Make the field non-editable
      isDisabled // Make the field appear disabled
      color="gray.400" // Set the text color to gray
    />
  ) : (
    <Input
      id="email"
      type="email"
      placeholder="Enter E-mail"
      boxShadow="md"
      borderColor={!!emailError ? 'red.300' : 'transparent'} // Change border color to red when there's an error
      value={email} // Allow user input
      onChange={handleEmailChange} // Handle user input
    />
  )}
  {emailError && (
    <FormErrorMessage color="red.500">{emailError}</FormErrorMessage>
  )}
              {emailError && (
                <FormErrorMessage color="red.500">
                  {emailError}
                </FormErrorMessage>
              )}
            </FormControl>
          </Box>

          {/* Confirm Email Address */}
          <Box flex="1" m={2} width="100%">
            <FormControl flex="1" m={2} isInvalid={!!emailError}>
              <FormLabel isRequired>Confirm Email</FormLabel>
              <Input
                id="confirm-email"
                type="email"
                placeholder="Confirm E-mail"
                boxShadow="md"
                borderColor={!!emailError ? 'red.300' : 'transparent'}
                onChange={handleConfirmEmailChange}
                value={userData.email}
                isReadOnly
                isDisabled
                backgroundColor="gray.400"
                color="black.400"
              />
              {emailError && (
                <FormErrorMessage color="red.500">
                  {emailError}
                </FormErrorMessage>
              )}
            </FormControl>
          </Box>
        </Flex>

        {/* Permanent and Current Address */}
        <HStack mt="40px" spacing={4}>
          <Box flex="1">
            <FormControl
              flex="1"
              m={2}
              isInvalid={!!permAddressError}
              isRequired
            >
              <FormLabel isRequired>Permanent Address</FormLabel>
              <InputGroup size="md">
                <Textarea
                  resize="none"
                  placeholder="Permanent Address"
                  onChange={handlePermAddressChange}
                  boxShadow="md"
                  borderColor={!!permAddressError ? 'red.300' : 'transparent'}
                />
              </InputGroup>
              {permAddressError && (
                <FormErrorMessage color="red.500">
                  {permAddressError}
                </FormErrorMessage>
              )}
            </FormControl>
          </Box>

          <Box flex="1">
            <FormControl
              flex="1"
              m={2}
              isInvalid={!!curAddressError}
              isRequired
            >
              <FormLabel>Current Address</FormLabel>
              <InputGroup size="md">
                <Textarea
                  resize="none"
                  placeholder="Current Address"
                  onChange={handleCurAddressChange}
                  boxShadow="md"
                  borderColor={!!curAddressError ? 'red.300' : 'transparent'}
                />
              </InputGroup>
              {curAddressError && (
                <FormErrorMessage color="red.500">
                  {curAddressError}
                </FormErrorMessage>
              )}
            </FormControl>
          </Box>
        </HStack>

        <Button mt="40px" colorScheme="blue" onClick={handleNext}>
          Submit
        </Button>
      </Box>
    </>
  );
};

export default Form1;
